import { Box, Paper, Stack, styled } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import "./headerNavigation.css";
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  //   color: theme.palette.text.secondary,
  marginLeft: `${theme.spacing(1.25)} !important`,
  marginRight: `${theme.spacing(1.25)} !important`,
  fontSize: "17px",

  fontWeight: 700,
}));

const HeaderNavigation = ({ value, location }) => {
  const navigate = useNavigate();
  
  return (
    <Box sx={{ width: "100%" }}>
      <Stack>
        <Item className="item">
          <span onClick={() => navigate(location)} sx={{cursor:"pointer"}}>{value}</span>
        </Item>
      </Stack>
    </Box>
  );
};

export default HeaderNavigation;
